import styled from 'styled-components';
import { ClockCircleFilled } from '@ant-design/icons';

export const Notification = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px 24px;
    align-items: flex-end;

    border-radius: 8px;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),
        0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
`;

export const IconClock = styled(ClockCircleFilled)`
    color: #6257d2;
    font-size: 24px;
`;
